import React, { useState } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Adjust the endpoint URL based on your configuration. If you removed the '/api/' prefix, use '/password_reset/'
      const response = await axios.post('https://lionfish-app-w73zu.ondigitalocean.app/api/password_reset/', { email });
      setMessage("If the email exists, a reset link has been sent.");
    } catch (error) {
      console.error("Password reset request failed:", error);
      setMessage("An error occurred while requesting password reset.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <form onSubmit={handleForgotPassword} className="forgot-password-form">
        <h2>Forgot Password?</h2>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? "Sending..." : "Send Reset Link"}
        </button>
        {message && <p className="forgot-password-message">{message}</p>}
      </form>
      <p>
        Remembered your password? <Link to="/login">Login</Link>
      </p>
    </div>
  );
};

export default ForgotPassword;
